module.exports = __webpack_public_path__ + "media/images/redesign-images/about-us/college-logos/tampa-15b2b5ee3659a467442501e48a95bf7c.svg";